import React, { FC } from "react";

import { Stack, Typography } from "@mui/material";

import HelpInfo from "../../../../components/HelpInfo";

type InnerSettingProps = React.PropsWithChildren<{
  label: string;
  customPaddingStyle?: boolean;
  docsKey?: string;
}>;
const InnerSetting: FC<InnerSettingProps> = ({ children, label, docsKey }) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:template-columns-[1fr_auto] items-center">
      <Stack gap={1}>
        <Typography
          variant="h6"
          sx={{
            minWidth: "20vw",
          }}
          className="flex items-center gap-1"
        >
          <span>{label}</span>
          {docsKey && <HelpInfo docsKey={docsKey} />}
        </Typography>
      </Stack>
      {children}
    </div>
  );
};
export default InnerSetting;
